import { render, staticRenderFns } from "./LogoAndBanner.vue?vue&type=template&id=0606cd52"
import script from "./LogoAndBanner.vue?vue&type=script&lang=ts"
export * from "./LogoAndBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports